import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowLeft: FC<Props> = ({ fill, ...otherProps }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...otherProps}
     aria-label="arrow left icon">
      {/* <title>arrow left icon</title> */}
      <path
        d="M20 12.2744C20 12.6541 19.7178 12.9678 19.3518 13.0175L19.25 13.0244L6.066 13.0238L10.829 17.7673C11.1225 18.0595 11.1235 18.5344 10.8313 18.8279C10.5656 19.0948 10.149 19.1199 9.85489 18.9027L9.77061 18.8302L3.72061 12.8062C3.68192 12.7677 3.64832 12.726 3.61979 12.682C3.61174 12.6687 3.60354 12.6552 3.59576 12.6413C3.58861 12.6295 3.58215 12.6172 3.57606 12.6047C3.56759 12.5866 3.55932 12.5679 3.55181 12.5488C3.5457 12.5341 3.54061 12.5198 3.53596 12.5053C3.53043 12.4875 3.52506 12.4684 3.52045 12.449C3.51701 12.4355 3.51429 12.4225 3.51192 12.4094C3.50859 12.39 3.50575 12.3699 3.50372 12.3496C3.50197 12.334 3.50092 12.3187 3.50034 12.3033C3.50019 12.2939 3.5 12.2842 3.5 12.2744L3.50038 12.2453C3.50095 12.2306 3.50196 12.2159 3.50339 12.2012L3.5 12.2744C3.5 12.227 3.50438 12.1807 3.51277 12.1358C3.51471 12.1251 3.51703 12.1141 3.51959 12.1031C3.52492 12.0806 3.53108 12.0588 3.53817 12.0375C3.54165 12.0269 3.5457 12.0156 3.55003 12.0044C3.5588 11.9818 3.56833 11.9603 3.5788 11.9393C3.58367 11.9295 3.58912 11.9192 3.59484 11.9089C3.60421 11.8923 3.61386 11.8765 3.62407 11.861C3.63128 11.8501 3.63925 11.8387 3.64758 11.8276L3.65407 11.8189C3.67428 11.7925 3.6962 11.7675 3.71967 11.744L3.72057 11.7433L9.77057 5.71833C10.0641 5.42604 10.5389 5.42703 10.8312 5.72052C11.0969 5.98734 11.1203 6.40406 10.9018 6.69721L10.829 6.78118L6.068 11.5238L19.25 11.5244C19.6642 11.5244 20 11.8601 20 12.2744Z"
        fill={fill || "currentColor"}
      />
    </svg>
  );
};

export default ArrowLeft;
